import React from 'react'
import Img from 'gatsby-image'

import BusinessSection from '@/business-section'
import LargeText from '@/large-text'

import './styles.css'

const SectionDigitalExperience = ({ gray, data }) => {
  return (
    <BusinessSection title="Digital Experience" gray={gray}>
      <div className="mw800 center">
        <Img sizes={data.digitalExperience.sizes} className="mb4 mw690 center" alt="" />

        <div className="">
          <LargeText>
            Every business is becoming a digital business. This applies to beauty pageant organisations as well. Today audiences have high expectations of what they want from their beauty pageants. This is where Next Miss can help your organisation with ready made turnkey solutions.
          </LargeText>

          <LargeText>
            Next Miss supports beauty pageant organisations by providing them with best in class digital solutions to all improve their offering to audiences. Our award-winning solutions are user experience obsessed and have direct impact on revenue generation, audience experience and overall business performance.
          </LargeText>

          <LargeText>
            It all may sound too technical. But worry not, our digital tools can be installed to your digital environment in minutes. No digital expertise is needed, we take care of everything for you. Contact us to learn more.
          </LargeText>
        </div>
      </div>
    </BusinessSection>
  )
}

export default SectionDigitalExperience



// WEBPACK FOOTER //
// ./src/components/section-digital-experience/section-digital-experience.js